import { useCallback } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import Subheader from 'components/atoms/GefMui/Subheader';
import PAGES from 'constants/pages';
import { MPU_DISPLAY_LEAD_MARKET } from 'features/common/acl/constants';
import { subheaders } from 'features/common/Subheader/constants';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { getVisibleStateById } from 'features/common/Subheader/selectors';
import { resetOrLoadUpMarketPlaceFilter } from 'features/views/marketPlace/actions';
import formDescriptorFn, { MARKET_PLACE_FORM_NAME } from 'features/views/marketPlace/form';
import { getContextUser } from 'features/views/userContext/selectors';

import MarketPlaceFilter from './components/MarketPlaceFilter';
import MarketPlaceLeads from './components/MarketPlaceLeads';
import MarketPlaceTable from './components/MarketPlaceTable';
import Toolbar from './components/Toolbar';

export const MarketPlace = () => {
	const dispatch = useDispatch();
	const contextUser = useSelector(getContextUser);
	const visibleState = useSelector((state) => getVisibleStateById(state, subheaders.marketPlace));

	const subheaderTitle = useRenderSubheaderTitle({
		contextUser,
		pageTitle: getLabelMessage('marketPlace:marketPlaceLeadsTitle'),
	});

	const handleToggleWithResultsUpdate = useCallback(() => {
		dispatch(resetOrLoadUpMarketPlaceFilter());
	}, [dispatch]);

	return (
		<Panel screenId={PAGES.marketPlace.id} screenName={PAGES.marketPlace.name}>
			<Paper sx={{ p: 3, borderRadius: 2 }}>
				<Stack spacing={2}>
					<Subheader title={subheaderTitle} />
					<AccessControl accessLevel={MPU_DISPLAY_LEAD_MARKET} showAccessDenied>
						<MarketPlaceLeads />
					</AccessControl>
				</Stack>
			</Paper>
			<PaperWithToolbar
				subheaderTitle={getLabelMessage('marketPlace:leads')}
				toggleFn={handleToggleWithResultsUpdate}
				toggledElement={
					<Form name={MARKET_PLACE_FORM_NAME} formDescriptorFn={formDescriptorFn}>
						<MarketPlaceFilter />
					</Form>
				}
				toolbar={<Toolbar />}
				collapsibleProps={{ id: subheaders.marketPlace, initiallyOpen: visibleState }}
			>
				<MarketPlaceTable />
			</PaperWithToolbar>
		</Panel>
	);
};

export default MarketPlace;
